export enum FeatureEntitlements {
  AutoSuggestShowRedirectType = 'auto_suggest_show_redirect_type',
  StorefrontBrandingCustomFonts = 'storefront_branding_custom_fonts',
  ScanAndPayRetailers = 'scan_and_pay_retailers',
  PageBuilder = 'page_builder',
  PageBuilderNavigateToFlyoutModal = 'page_builder_navigate_to_flyout_modal',
  Navigation = 'navigation',
}
